import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { glass } from "./portal";
import { toast } from "sonner";
import { useQuery } from "@tanstack/react-query";

export const Route = createFileRoute("/_authenticated/portal/settings")({
  component: SettingsPage,
});

function SettingsPage() {
  const { data: me } = useQuery({ queryKey: ["portal", "me"], queryFn: async () => (await supabase.auth.getUser()).data.user });
  const [company, setCompany] = useState((me?.user_metadata as { company?: string } | undefined)?.company ?? "");
  const [phone, setPhone] = useState((me?.user_metadata as { phone?: string } | undefined)?.phone ?? "");
  const [pw, setPw] = useState("");
  const [notifEmail, setNotifEmail] = useState(true);
  const [twoFA, setTwoFA] = useState(false);
  const [lang, setLang] = useState("it");

  const saveProfile = async () => {
    const { error } = await supabase.auth.updateUser({ data: { company, phone } });
    if (error) return toast.error(error.message);
    toast.success("Profilo aggiornato");
  };
  const changePw = async () => {
    if (pw.length < 6) return toast.error("Min 6 caratteri");
    const { error } = await supabase.auth.updateUser({ password: pw });
    if (error) return toast.error(error.message);
    setPw(""); toast.success("Password aggiornata");
  };

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">Impostazioni</h1>
        <p className="text-white/60 mt-1">Profilo, sicurezza, notifiche.</p>
      </div>

      <Section title="Informazioni azienda">
        <Field label="Email"><input value={me?.email ?? ""} disabled className="w-full rounded-xl bg-white/5 border border-white/10 px-3 py-2 text-sm opacity-60" /></Field>
        <Field label="Nome azienda"><input value={company} onChange={(e) => setCompany(e.target.value)} className="w-full rounded-xl bg-white/5 border border-white/10 px-3 py-2 text-sm" /></Field>
        <Field label="Telefono / WhatsApp"><input value={phone} onChange={(e) => setPhone(e.target.value)} className="w-full rounded-xl bg-white/5 border border-white/10 px-3 py-2 text-sm" /></Field>
        <button onClick={saveProfile} className="px-4 py-2 rounded-full bg-white text-black text-sm font-medium">Salva</button>
      </Section>

      <Section title="Sicurezza">
        <Field label="Nuova password"><input type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="w-full rounded-xl bg-white/5 border border-white/10 px-3 py-2 text-sm" /></Field>
        <button onClick={changePw} className="px-4 py-2 rounded-full bg-white/10 text-sm">Aggiorna password</button>
        <Toggle label="Two-factor authentication" on={twoFA} onChange={setTwoFA} />
      </Section>

      <Section title="Notifiche">
        <Toggle label="Email per ticket e aggiornamenti" on={notifEmail} onChange={setNotifEmail} />
      </Section>

      <Section title="Lingua">
        <select value={lang} onChange={(e) => setLang(e.target.value)} className="rounded-xl bg-white/5 border border-white/10 px-3 py-2 text-sm">
          <option value="it" className="bg-black">Italiano</option>
          <option value="en" className="bg-black">English</option>
          <option value="de" className="bg-black">Deutsch</option>
          <option value="fr" className="bg-black">Français</option>
        </select>
      </Section>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return <div className={`${glass} p-6 space-y-4`}><div className="text-sm font-semibold">{title}</div>{children}</div>;
}
function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return <div><label className="text-xs text-white/50 block mb-1.5">{label}</label>{children}</div>;
}
function Toggle({ label, on, onChange }: { label: string; on: boolean; onChange: (v: boolean) => void }) {
  return (
    <label className="flex items-center justify-between cursor-pointer">
      <span className="text-sm">{label}</span>
      <button type="button" onClick={() => onChange(!on)} className={`h-6 w-11 rounded-full transition relative ${on ? "bg-gradient-to-r from-fuchsia-500 to-cyan-400" : "bg-white/10"}`}>
        <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-white transition ${on ? "left-5" : "left-0.5"}`} />
      </button>
    </label>
  );
}
